import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M51.772 82.728a3.63 3.63 0 0 0 3.629 3.636h5.23a3.636 3.636 0 0 0 0-7.273h-1.594v-5.58h7.798c7.266 0 13.175-5.914 13.175-13.181V38.759c0-4.07-2.042-7.816-5.47-10.022l-22.572-14.52a3.63 3.63 0 0 0-3.91-.018L25.538 28.437a11.84 11.84 0 0 0-5.549 10.071V60.33c0 7.265 5.91 13.182 13.182 13.182h7.79v5.58h-1.594a3.635 3.635 0 0 0-3.629 3.636 3.635 3.635 0 0 0 3.63 3.636h5.23a3.64 3.64 0 0 0 3.636-3.636V66.241H33.172a5.914 5.914 0 0 1-5.915-5.91V38.51c0-1.602.813-3.075 2.17-3.93l20.556-12.997 20.63 13.272a4.63 4.63 0 0 1 2.133 3.906v21.57a5.914 5.914 0 0 1-5.909 5.91H51.774v16.487zm-4.504-32.587a5.496 5.496 0 1 1-10.993 0 5.496 5.496 0 0 1 10.993 0m16.457 0a5.495 5.495 0 0 1-5.497 5.496 5.496 5.496 0 1 1 5.496-5.496"
    }, null, -1)
  ])))
}
export default { render: render }